var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"appear":""}},[_c('h4',[_vm._v("Loading")])])
}
var staticRenderFns = []

export { render, staticRenderFns }